import React from 'react';
import {convertDurationsToMonths} from '../utils/durationUtils';
import RangeSlider from './RangeSlider';
import { formatCurrency } from '../utils/currencyUtils';
import './LoanForm.css';

const LoanForm = ({
                      productData,
                      amountSelected,
                      durationSelected,
                      currency,
                      installmentDetails,
                      handleAmountChange,
                      handleDurationChange,
                      onSubmit,
                      onSecciRequest,
                      getValidDurations,
                      isMobile,
                      labels,
                      isLoading,
                  }) => {
    if (!productData) return null;

    const durations = isLoading
        ? [1, 3, 6, 9, 12]
        : convertDurationsToMonths(getValidDurations());

    return (
        <form onSubmit={onSubmit} className={`loan-form ${isLoading ? 'loading-state' : ''}`}>
            <div className="slider-container">
                {labels.loanAmountLabel && (
                    <div className="label-container center">
                        <h2>{labels.loanAmountLabel}</h2>
                    </div>
                )}
                <div className="label-container">
                    <p className="priceclass">{formatCurrency(installmentDetails.principal, 0)} <span> {currency}</span></p>
                </div>
                <div className="label-container">
                    <span className="label-text">{labels.monthlyLabel || "Loan Duration (Months)"}</span>
                    <span className="value-text"> {formatCurrency(installmentDetails.installmentAmount,  labels.numDecimalMonthly)}
                        <span> {currency}</span> </span>
                </div>
                <div className="sliders">
                    <RangeSlider
                        values={productData.amountRange}
                        value={amountSelected}
                        onChange={handleAmountChange}
                        hideFromTo={true}
                        hideMinMax={true}
                        disabled={isLoading}
                    />

                    <div className="label-container">
                        <span className="label-text">{labels.durationLabel || "Loan Duration (Months)"}</span>
                        <span className="value-text">{durationSelected} {labels.monthsLabel}</span>
                    </div>
                    <RangeSlider
                        values={durations}
                        value={durationSelected}
                        onChange={handleDurationChange}
                        hideFromTo={true}
                        hideMinMax={true}
                        disabled={isLoading}
                    />
                </div>
                <div className="label-container">
                    <a
                        href="#"
                        className={`secci-button ${isLoading ? 'disabled' : ''}`}
                        onClick={(e) => {
                            e.preventDefault();
                            if (!isLoading) onSecciRequest();
                        }}
                    >
                        {labels.infoLinkLabel || "View SECCI Document"}
                    </a>
                </div>
            </div>

            <div className="button-container">

                <button
                    type="submit"
                    className={`apply-button ${isLoading ? 'disabled' : ''}`}
                    id={isMobile ? 'applyButtonMobile' : 'applyButton'}
                    disabled={isLoading}
                >
                    {labels.submitLabel || "Apply Now"}
                </button>
            </div>
        </form>
    );
};

export default LoanForm;
